import React__default, { useMemo, useContext, createContext } from 'react';

const defaultContext = {
  experimental: false,
  usesSortableLibrary: false,
  usesBottomSheet: false,
  disablesRightSidebar: false
};
const FeaturesContext = /*#__PURE__*/createContext(defaultContext);
function FeaturesProvider({
  features,
  children
}) {
  const contextValue = useMemo(() => ({
    ...defaultContext,
    ...features
  }), [features]);
  return /*#__PURE__*/React__default.createElement(FeaturesContext.Provider, {
    value: contextValue
  }, children);
}
function useFeatures() {
  return useContext(FeaturesContext);
}

export { FeaturesProvider, useFeatures };
